import { render, staticRenderFns } from "./inventory-list-fifo.vue?vue&type=template&id=664f4c5e&"
import script from "./inventory-list-fifo.vue?vue&type=script&lang=js&"
export * from "./inventory-list-fifo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports